import type { DockLayout } from './chat-dock-store';

/** Background tabs/windows must still receive attention for their open chats. */
export function isDocumentAttended(): boolean {
  return typeof document !== 'undefined'
    && document.visibilityState === 'visible'
    && document.hasFocus();
}

/** Same exact-conversation rule for realtime notifications and unread previews. */
export function isTeamChatAttended(
  channelId: string,
  dock: DockLayout,
  fullViewChannelId: string | null,
  documentAttended: boolean,
): boolean {
  return documentAttended && (
    fullViewChannelId === channelId
    || (dock.openChats.includes(channelId) && !dock.minimized.includes(channelId))
  );
}

/** React subscribes to browser attention without polling or derived state effects. */
export function subscribeDocumentAttention(onChange: () => void): () => void {
  if (typeof document === 'undefined' || typeof window === 'undefined') return () => {};
  document.addEventListener('visibilitychange', onChange);
  window.addEventListener('focus', onChange);
  window.addEventListener('blur', onChange);
  return () => {
    document.removeEventListener('visibilitychange', onChange);
    window.removeEventListener('focus', onChange);
    window.removeEventListener('blur', onChange);
  };
}

export const serverDocumentAttention = () => false;
